import React, { useState } from 'react';
import { Artifact, APPROVE_LABELS, SHOW_DISCARD } from './types';
import { RefineInput } from './RefineInput';
interface ArtifactActionsProps {
  artifact: Artifact;
  onApprove?: () => void;
  onRefine?: (comment: string) => void;
  onDiscard?: () => void;
  compact?: boolean;
}
export function ArtifactActions({
  artifact,
  onApprove,
  onRefine,
  onDiscard,
  compact
}: ArtifactActionsProps) {
  const [showRefine, setShowRefine] = useState(false);
  const approveLabel = APPROVE_LABELS[artifact.type] || 'Approve';
  const showDiscard = SHOW_DISCARD.has(artifact.type);
  const isActionable = artifact.status === 'pending' || artifact.status === 'refined';
  const handleRefineSubmit = (comment: string) => {
    setShowRefine(false);
    onRefine?.(comment);
  };
  if (!isActionable && artifact.status !== 'delivered') return null;
  return <div className="flex flex-col gap-2" data-id="element-169">
      {showRefine && <RefineInput onSubmit={handleRefineSubmit} onCancel={() => setShowRefine(false)} data-id="element-170" />}
      <div className={`flex items-center gap-2 ${compact ? '' : 'px-4 pb-3'}`} data-id="element-171">
        {isActionable && <>
            <button onClick={onApprove} className={`bg-[#4a9a9a] text-[#141418] rounded-lg font-semibold transition-colors hover:bg-[#5bb5b5] ${compact ? 'px-3 py-1 text-[11px]' : 'px-4 py-1.5 text-[12px]'}`} data-id="element-172">
              {approveLabel}
            </button>
            <button onClick={() => setShowRefine(!showRefine)} className={`bg-white/[0.04] text-[#8a8680] rounded-lg transition-colors hover:text-[#e8e4df] hover:bg-white/[0.08] ${compact ? 'px-3 py-1 text-[11px]' : 'px-4 py-1.5 text-[12px]'}`} data-id="element-173">
              Refine
            </button>
            {showDiscard && <button onClick={onDiscard} className={`bg-white/[0.04] text-[#8a8680] rounded-lg transition-colors hover:text-[#f47067] hover:bg-white/[0.08] ${compact ? 'px-3 py-1 text-[11px]' : 'px-4 py-1.5 text-[12px]'}`} data-id="element-174">
                Discard
              </button>}
          </>}
      </div>
    </div>;
}